export const TIANDITU_TK =
  process.env.VUE_APP_TIANDITU_TK?.trim() || '3ffb7c62a2a244fd3259546ccce7bdff'

export function tiandituWmtsUrl(layer, matrixSet = 'w') {
  return (
    `https://t0.tianditu.gov.cn/${layer}_${matrixSet}/wmts?` +
    'SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0' +
    `&LAYER=${layer}&STYLE=default&TILEMATRIXSET=${matrixSet}` +
    '&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}' +
    `&tk=${encodeURIComponent(TIANDITU_TK)}`
  )
}
